import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "@/store/use-auth-store";
import React from "react";
// Barrel yerine doğrudan hook dosyası: her route guard'ın bundle'ına
// PersonaSetupPage UI'ı ve adım bileşenleri girmesin.
import {
  resolvePostLoginRedirect,
  usePostLoginGate,
} from "@/features/persona-setup/hooks/use-post-login-gate";
import { AppGateSplash } from "@/components/common/AppGateSplash";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export function PrivateRoute({ children }: PrivateRouteProps) {
  const { user, refreshToken, isTokenExpired } = useAuthStore();
  const location = useLocation();
  const gate = usePostLoginGate();

  const hasSession = !!(user && (!isTokenExpired() || refreshToken));

  if (!hasSession) {
    return <Navigate to="/login" replace />;
  }

  const redirect = resolvePostLoginRedirect(location.pathname, gate);

  if (redirect === "loading") {
    return <AppGateSplash />;
  }

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
}
